const heroes = Array.from(document.querySelectorAll(".backdrop-hero"));

function checkSizes(hero) {
    const image = hero.querySelector('.backdrop-hero__background div')
    const content = hero.querySelector('.backdrop-hero__foreground .container')

    const imageHeight = image.getBoundingClientRect().height
    const contentHeight = content.getBoundingClientRect().height

    if (window.innerWidth > 1024) {

        if (imageHeight >= contentHeight) {
            hero.classList.add('backdrop-hero--tall-image');
        } else {
            hero.classList.remove('backdrop-hero--tall-image');
        }
    }
}

function setup(hero) {

    checkSizes(hero)

    window.addEventListener('resize', () => {
        checkSizes(hero)
    })

}

function init() {
    if (!heroes.length) return;

    heroes.forEach(setup)
}

window.addEventListener('load', function () {
    init();
})
